import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-provider-leftcontent',
  templateUrl: './provider-leftcontent.component.html',
  styleUrls: ['./provider-leftcontent.component.css']
})
export class ProviderLeftcontentComponent implements OnInit {
  corpCode: any = ''
  mfaURL :any;
  state:any;
  showlink:boolean;
  
  constructor() { }

  ngOnInit(): void {
  
  this.showlink = environment.BAP_SHOW_LINK;

    let urlArray = window.location.href.split(".com");
    this.corpCode = urlArray.length == 1 ? 'il' : urlArray[0].slice(-2);
    this.state=urlArray.length == 1 ? 'il' : urlArray[0].slice(-2);

     this.mfaURL='assets/BAPP-two-step-login-and-faqs v2.pdf';
  }
 
}
